'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactLazyLoad = require('react-lazy-load');

var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);

var _uiExternalLink = require('@spp/ui-external-link');

var _uiExternalLink2 = _interopRequireDefault(_uiExternalLink);

var _EmbedIframe = require('./EmbedIframe');

var _EmbedIframe2 = _interopRequireDefault(_EmbedIframe);

var _EmbedHtml = require('./EmbedHtml');

var _EmbedHtml2 = _interopRequireDefault(_EmbedHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIDEO_DEFAULT_RATIO = 16 / 9;

var EmbedContent = function EmbedContent(props) {
    var theme = props.theme,
        url = props.url,
        subtype = props.subtype,
        _props$title = props.title;
    _props$title = _props$title === undefined ? {} : _props$title;
    var titleValue = _props$title.value,
        isVideo = props.isVideo,
        includeHeadline = props.includeHeadline,
        lazyLoad = props.lazyLoad,
        _props$data = props.data;
    _props$data = _props$data === undefined ? {} : _props$data;
    var _props$data$embed = _props$data.embed;
    _props$data$embed = _props$data$embed === undefined ? {} : _props$data$embed;
    var iframeUrl = _props$data$embed.iframeUrl,
        html = _props$data$embed.html,
        height = _props$data$embed.height,
        aspectRatio = _props$data$embed.aspectRatio;


    var useAspectRatio = (aspectRatio || isVideo) && iframeUrl;

    if (!iframeUrl && !html) {
        return _react2.default.createElement(
            _uiExternalLink2.default,
            { href: url },
            titleValue || url
        );
    }

    // only use height prop for non-video iframe embeds
    var customMinHeight = typeof height === 'number' && !isVideo && !aspectRatio ? height : undefined;

    // only use aspectRatio prop for iframe embeds
    // fallback to VIDEO_DEFAULT_RATIO for videos (no aspectRatio for non-videos)
    var rootStyle = useAspectRatio ? { paddingTop: 100 / (aspectRatio || VIDEO_DEFAULT_RATIO) + '%' } : {};

    var rootClass = (0, _classnames3.default)(theme.root, theme[subtype], (0, _defineProperty3.default)({}, theme.aspectRatio, useAspectRatio));

    var embedContent = _react2.default.createElement(
        'div',
        { className: rootClass, 'data-test-tag': '@spp/ui-embed-content', style: rootStyle },
        includeHeadline && titleValue ? _react2.default.createElement(
            'h3',
            { className: theme.visuallyhidden },
            titleValue
        ) : null,
        iframeUrl ? _react2.default.createElement(_EmbedIframe2.default, (0, _extends3.default)({ customMinHeight: customMinHeight }, props)) : _react2.default.createElement(_EmbedHtml2.default, props)
    );

    if (lazyLoad) {
        var _ref = lazyLoad === true ? {} : lazyLoad,
            _ref$offset = _ref.offset,
            offset = _ref$offset === undefined ? 500 : _ref$offset,
            _ref$debounce = _ref.debounce,
            debounce = _ref$debounce === undefined ? false : _ref$debounce,
            _ref$throttle = _ref.throttle,
            throttle = _ref$throttle === undefined ? 100 : _ref$throttle;

        return _react2.default.createElement(
            _reactLazyLoad2.default,
            { offset: offset, debounce: debounce, throttle: throttle },
            embedContent
        );
    }

    return embedContent;
};

EmbedContent.propTypes = {
    url: _propTypes2.default.string.isRequired,
    subtype: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
        externalLink: _propTypes2.default.string,
        root: _propTypes2.default.string,
        iframeContent: _propTypes2.default.string,
        video: _propTypes2.default.string,
        visuallyhidden: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        embed: _propTypes2.default.shape({
            iframeUrl: _propTypes2.default.string,
            height: _propTypes2.default.number,
            width: _propTypes2.default.number
        })
    }),
    title: _propTypes2.default.shape({
        value: _propTypes2.default.string
    }),
    isVideo: _propTypes2.default.bool,
    includeHeadline: _propTypes2.default.bool,
    lazyLoad: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
        offset: _propTypes2.default.number,
        debounce: _propTypes2.default.bool,
        throttle: _propTypes2.default.number
    })])
};

EmbedContent.defaultProps = {
    theme: {},
    title: {},
    data: {},
    isVideo: false,
    includeHeadline: false,
    subtype: undefined,
    lazyLoad: true
};

exports.default = EmbedContent;
//# sourceMappingURL=EmbedContent.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-embed-content/lib/cjs/EmbedContent.js
 ** module id = 502
 ** module chunks = 1
 **/